module.exports = __webpack_public_path__ + "img/onePieceSkirt.128fd85f.png";